module.exports = __webpack_public_path__ + "media/images/new-ui-images/share-icon-circule-616ae4ff47a1ebc1d7a7a20a5aa55ca6.svg";